import React from "react";

const Icon = ({value}: {value: boolean}) => value ? <img src={'/img/green2-check.svg'}/> : <img src={'/img/red-close.svg'}/>

export default Icon;
